enum namespace {
  app = 'app',
  /** 首页推荐 */
  home = 'home',
  /** 首页活动 */
  activity = 'activity',
  /** 帖子详情 */
  detail = 'detail',
  /** 首页广场 */
  square = 'square',
  /** 发帖页 */
  edit = 'edit',
  /** 首页咨询 */
  consult = 'consult',
  /** 设备圈 */
  devices = 'devices',
  /** 设备主题 */
  device = 'device',
  /** 用户名头像修改页 **/
  profile = 'profile',
  /** 所有圈子 **/
  group = 'group',
  /** 搜索结果页 **/
  search = 'search',
}

export default namespace;
